import { useEffect, useState } from "react";

const BRANDS = [
  { name: "Picard", domain: "picardserrures.com", color: "#003D7A" },
  { name: "Fichet", domain: "fichet-pointfort.com", color: "#0066B3" },
  { name: "Bricard", domain: "bricard.fr", color: "#E30613" },
  { name: "Vachette", domain: "assaabloy.com", color: "#003B71" },
  { name: "Mul-T-Lock", domain: "mul-t-lock.com", color: "#C8102E" },
  { name: "Héraclès", domain: "heracles.fr", color: "#003366" },
  { name: "ISEO", domain: "iseo.com", color: "#E20613" },
  { name: "Yale", domain: "yale.fr", color: "#003F87" },
  { name: "JPM", domain: "jpm-france.com", color: "#003D7A" },
  { name: "ABUS", domain: "abus.com", color: "#005CA9" },
  { name: "Tesa", domain: "tesa.es", color: "#0079C1" },
  { name: "Pollux", domain: "pollux.fr", color: "#1E3A8A" },
];

function BrandLogo({ brand }) {
  // Cycle through 3 logo sources: Clearbit (HD logo) → Logo.dev fallback → Google favicon (always works)
  const sources = [
    `https://logo.clearbit.com/${brand.domain}?size=240`,
    `https://www.google.com/s2/favicons?domain=${brand.domain}&sz=128`,
  ];
  const [idx, setIdx] = useState(0);
  const [textOnly, setTextOnly] = useState(false);

  const handleError = () => {
    if (idx < sources.length - 1) {
      setIdx(idx + 1);
    } else {
      setTextOnly(true);
    }
  };

  return (
    <div
      className="flex items-center justify-center gap-3 h-20 sm:h-24 px-6 min-w-[180px] bg-white border-2 transition-all hover:shadow-lg"
      style={{ borderColor: brand.color + "20" }}
    >
      {!textOnly && (
        <img
          src={sources[idx]}
          alt={brand.name}
          loading="lazy"
          onError={handleError}
          className="max-h-10 sm:max-h-12 w-auto object-contain flex-shrink-0"
        />
      )}
      <span
        className="font-display font-black uppercase tracking-tight text-base sm:text-lg whitespace-nowrap"
        style={{ color: brand.color }}
      >
        {brand.name}
      </span>
    </div>
  );
}

export default function Brands() {
  const list = [...BRANDS, ...BRANDS];
  return (
    <section data-testid="brands-section" className="bg-white border-y border-black/10 py-10 sm:py-12 reveal">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
        <div>
          <div className="text-[11px] tracking-[0.25em] uppercase font-bold text-red-600 mb-2">
            — Marques que nous installons & dépannons
          </div>
          <div className="font-display font-bold text-lg sm:text-xl text-[#0A0A0A]">
            Toutes serrures certifiées <span className="text-red-600">A2P</span> et grandes marques
          </div>
        </div>
        <div className="text-sm text-slate-500">
          12+ marques · pièces d'origine · garantie constructeur
        </div>
      </div>

      <div className="overflow-hidden">
        <div className="marquee-track items-center gap-3">
          {list.map((b, i) => (
            <div key={i} className="flex-shrink-0 mx-1">
              <BrandLogo brand={b} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
